module.exports = __webpack_public_path__ + "static/media/people2-min.24acb492.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/people2-min.png
// module id = 451
// module chunks = 0